import classNames from 'classnames/bind';
import styles from './ClassStudentInfo.module.css';
import { StudentMgmt } from '../../../types/analysis';
import {
  APPROVAL,
  DEPARTMENT,
  EMAIL_INFO,
  GRADE,
  MANAGEMENT_APPROVAL_DATE,
  MANAGEMENT_REQUEST_DATE,
  MANAGEMENT_STATUS,
  MANAGE_STUDENT,
  NAME,
  NICKNAME,
  SCHOOL_GRADE,
  SCHOOL_NAME,
  STUDENT_INFO,
  STUDENT_MANAGEMENT_INFO,
  USER_STATUS,
} from '../../../constants';
import useModal from '../../../hooks/useModal';
import { useAppSelector } from '../../../hooks/useRedux';
import { selectStudentUserId } from '../../../features/analysisSlice';

interface ClassStudentInfo {
  data: StudentMgmt;
}
export default function ClassStudentInfo({
  data: {
    dispUserStatus,
    dispMgmtStatus,
    dispRequestDate,
    dispApprovalDate,
    email,
    nm,
    alias,
    schoolTypeCd,
    schoolNm,
    gradeTypeCd,
    departmentTypeCd,
  },
}: ClassStudentInfo) {
  const cx = classNames.bind(styles);
  const { toggleModal } = useModal();
  const userId = useAppSelector(selectStudentUserId);

  return (
    <div className={cx('dash_student_info')}>
      <div className={cx('box')}>
        <h3 className={cx('tit')}>{STUDENT_MANAGEMENT_INFO}</h3>
        <ul className={cx('list')}>
          <li>
            <span>{USER_STATUS}</span>
            <span>{dispUserStatus}</span>
          </li>
          <li>
            <span>{MANAGEMENT_STATUS}</span>
            <span className={cx({ status_info: dispMgmtStatus === APPROVAL })}>
              {dispMgmtStatus}
            </span>
          </li>
          <li>
            <span>{MANAGEMENT_REQUEST_DATE}</span>
            <span>{dispRequestDate}</span>
          </li>
          <li>
            <span>{MANAGEMENT_APPROVAL_DATE}</span>
            <span>{dispApprovalDate}</span>
          </li>
        </ul>
      </div>

      <div className={cx('box')}>
        <h3 className={cx('tit')}>{STUDENT_INFO}</h3>
        <ul className={cx('list')}>
          <li>
            <span>{EMAIL_INFO}</span>
            <span>{email}</span>
          </li>
          <li>
            <span>{NAME}</span>
            <span>{nm}</span>
          </li>
          <li>
            <span>{NICKNAME}</span>
            <span>{alias}</span>
          </li>
        </ul>
        <ul className={cx('list')}>
          <li>
            <span>{SCHOOL_GRADE}</span>
            <span>{schoolTypeCd}</span>
          </li>
          <li>
            <span>{SCHOOL_NAME}</span>
            <span>{schoolNm}</span>
          </li>
          <li>
            <span>{GRADE}</span>
            <span>{gradeTypeCd}</span>
          </li>
          <li>
            <span>{DEPARTMENT}</span>
            <span>{departmentTypeCd}</span>
          </li>
        </ul>
      </div>

      <div className={cx('btn_wrap')}>
        <button
          className={cx('btn', 'skyt', 'student_modify')}
          onClick={() => {
            toggleModal({
              id: 'confirmMoveClass',
              type: 'confirm',
              data: { userId },
            });
          }}
        >
          <span>{MANAGE_STUDENT}</span>
        </button>
      </div>
    </div>
  );
}
